const digits = value => String(value || '').replace(/\D/g, '');
const repeated = value => /^(\d)\1+$/.test(value);

export const isValidCpf = value => {
  const cpf = digits(value);
  if (cpf.length !== 11 || repeated(cpf)) return false;

  const digit = length => {
    const total = cpf
      .slice(0, length)
      .split('')
      .reduce(
        (sum, number, index) => sum + Number(number) * (length + 1 - index),
        0
      );
    const remainder = total % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  return digit(9) === Number(cpf[9]) && digit(10) === Number(cpf[10]);
};

export const isValidCnpj = value => {
  const cnpj = digits(value);
  if (cnpj.length !== 14 || repeated(cnpj)) return false;

  const checkDigit = length => {
    let weight = length - 7;
    const total = cnpj
      .slice(0, length)
      .split('')
      .reduce((sum, number) => {
        const result = sum + Number(number) * weight;
        weight -= 1;
        if (weight < 2) weight = 9;
        return result;
      }, 0);
    const remainder = total % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  return (
    checkDigit(12) === Number(cnpj[12]) && checkDigit(13) === Number(cnpj[13])
  );
};

export const isValidPixDocument = value => {
  const document = digits(value);
  return document.length <= 11 ? isValidCpf(document) : isValidCnpj(document);
};

export const formatCpf = value =>
  digits(value)
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

export const formatCnpj = value =>
  digits(value)
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');

export const formatPixDocument = value =>
  digits(value).length <= 11 ? formatCpf(value) : formatCnpj(value);

export const pixDocumentKind = value =>
  digits(value).length <= 11 ? 'cpf' : 'cnpj';
